import { render, staticRenderFns } from "./WidgetFilterMenu.vue?vue&type=template&id=2a28069f&scoped=true"
import script from "./WidgetFilterMenu.vue?vue&type=script&lang=js"
export * from "./WidgetFilterMenu.vue?vue&type=script&lang=js"
import style0 from "./WidgetFilterMenu.vue?vue&type=style&index=0&id=2a28069f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a28069f",
  null
  
)

export default component.exports